<div class="dark-theme">
    <div class="modal-header">
        <h3> Cookies Disclaimer </h3>
    </div>
    <div class="modal-body">
        <mat-tab-group (selectedTabChange)="onTabChange()">
            <mat-tab label="Consent">
                    <div class="content-box tile tab-content scrollable" [class.animate]="animateTab" cdkFocusInitial>
                        <span>
                            TK Elevator GmbH does not use cookies to collect information about users. It only uses first-party cookies for necessary and/or technical purposes (those that allow the user to browse the website and use the different options and services it offers).
                            More information about the cookies by clicking on '<a style="color"href="/legal/cookie-policy.html" target="_blank" rel="noopener noreferrer">Cookies Policy</a>'.
                        </span>
                        <form class="" [formGroup]="cookieForm">
                            <div class="form-group ps-2 pt-10"
                                 [ngClass]="{
                                    'form-error':
                                        (cookieForm.controls['technical'].touched || cookieForm.controls['technical'].dirty) &&
                                        !cookieForm.controls['technical'].valid
                                }">
                                <input kendoCheckBox formControlName="technical" type="checkbox" id="technical" />
                                <label class="k-checkbox-label" for="technical">
                                    Technical (Mandatory)
                                </label>
                            </div>
                        </form>
                    </div>
            </mat-tab>
            <mat-tab label="About">
                    <div class="content-box tile tab-content scrollable" [class.animate]="animateTab">
                        <p [innerHtml]="COOKIE_DISCLAIMER_ABOUT_TEXT"></p>
                    </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div class="modal-footer">
        <button class="btn button-fix button-color-fix-orange" (click)="acceptAll()">ACCEPT</button>
    </div>
</div>